import React, { useState, useEffect } from "react";
import { bool, string, number, func } from "prop-types";
import DatePicker from "react-datepicker";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { es } from 'date-fns/locale';
import { formatDate, isValidDate } from "../../utils/dateHelpers";
import { GLOBAL } from '../../Config/global';
import './styles.scss';

// Registrar locale español
registerLocale('es', es);
setDefaultLocale('es');

const { RANGE_DATEPICKER } = GLOBAL.RANGE_DATEPICKER;

const RangeDatePicker = ({ disabled = false, displayFormat = "DD/MM/YYYY", initialStartDate = null, initialEndDate = null, firstDayOfWeek = 0, numberOfMonths = 2, inputIconPosition = "after", onChange = () => null, isOutsideRange = () => false }) => {
  const parseDate = (dateString) => {
    if (!dateString) return null;
    const date = new Date(dateString);
    return isNaN(date.getTime()) ? null : date;
  };

  const [dates, setDates] = useState({
    startDate: parseDate(initialStartDate),
    endDate: parseDate(initialEndDate)
  });

  const handleStartDateChange = (date) => {
    const newDates = { ...dates, startDate: date };
    setDates(newDates);
    
    onChange({
      startDate: date ? formatDate(date, displayFormat) : null,
      endDate: dates.endDate ? formatDate(dates.endDate, displayFormat) : null
    });
  };

  const handleEndDateChange = (date) => {
    const newDates = { ...dates, endDate: date };
    setDates(newDates);
    
    onChange({
      startDate: dates.startDate ? formatDate(dates.startDate, displayFormat) : null,
      endDate: date ? formatDate(date, displayFormat) : null
    });
  };

  const StartDateInput = React.forwardRef(({ value, onClick }, ref) => (
    <div className="react-datepicker__input-container">
      <input
        ref={ref}
        type="text"
        value={value}
        onClick={onClick}
        placeholder={RANGE_DATEPICKER.START_DATE_PLACEHOLDER}
        disabled={disabled}
        className="form-control"
      />
      <i className="bi bi-calendar green-icon react-datepicker__calendar-icon"></i>
    </div>
  ));

  const EndDateInput = React.forwardRef(({ value, onClick }, ref) => (
    <div className="react-datepicker__input-container">
      <input
        ref={ref}
        type="text"
        value={value}
        onClick={onClick}
        placeholder={RANGE_DATEPICKER.END_DATE_PLACEHOLDER}
        disabled={disabled}
        className="form-control"
      />
      <i className="bi bi-calendar green-icon react-datepicker__calendar-icon"></i>
    </div>
  ));

  return (
    <div className="range-datepicker-container">
      <div className="range-datepicker-inputs">
        <div className="range-datepicker-input">
          <label>Fecha Inicio</label>
          <DatePicker
            selected={dates.startDate}
            onChange={handleStartDateChange}
            locale="es"
            dateFormat={displayFormat.toLowerCase().replace('dd', 'dd').replace('yyyy', 'yyyy')}
            customInput={<StartDateInput />}
            disabled={disabled}
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
            calendarClassName="react-datepicker-custom"
          />
        </div>
        <div className="range-datepicker-input">
          <label>Fecha Fin</label>
          <DatePicker
            selected={dates.endDate}
            onChange={handleEndDateChange}
            locale="es"
            dateFormat={displayFormat.toLowerCase().replace('dd', 'dd').replace('yyyy', 'yyyy')}
            customInput={<EndDateInput />}
            disabled={disabled}
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
            calendarClassName="react-datepicker-custom"
            minDate={dates.startDate}
          />
        </div>
      </div>
    </div>
  );
};

RangeDatePicker.propTypes = {
  disabled: bool,
  displayFormat: string,
  initialStartDate: string,
  initialEndDate: string,
  firstDayOfWeek: number,
  numberOfMonths: number,
  inputIconPosition: string,
  onChange: func,
  isOutsideRange: func
};



export default RangeDatePicker;
